<template>
  <div id="apork-counter-area" class="apork-counter-area mt-100 mb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-8 col-lg-12 mx-auto">
          <div class="row counter-parent justify-content-between">
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-4">
              <div class="single-counter text-center">
                <countTo
                  class="counter wow " 
                  :endVal="webData.downs"
                  :duration="2000"
                ></countTo>

                <span>下载次数</span>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-4">
              <div class="single-counter text-center">
                <countTo
                  class="counter wow "
                  :endVal="webData.active"
                  :duration="2000"
                ></countTo>
                <span>活跃用户</span>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-4 col-sm-4">
              <div class="single-counter text-center">
                <countTo
                  class="counter wow "
                  :endVal="webData.goods"
                  :duration="2000"
                ></countTo>
                <span>好评次数</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
export default {
  name: "IndexCounter",
  components: { countTo },
  data() {
    return {
      webData: {
        downs: 67800,
        goods: 5100,
        active: 489,
      },
    };
  },
};
</script>

<style lang="less" scoped>
.counter {
  color: #1a2b3c;
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 7px;
  display: block;
}
</style>